import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  body {
    margin: 0;
    background-color: #EF3E36;
    font-family: 'Racing Sans One';
  }
`;

export default GlobalStyles;
